import React from "react";
import {PageHeader} from "../components/layout/PageHeader";
import {useHistory} from "react-router-dom";
import {CertificateDto} from "../generated-api";
import {ScanQrCode} from "../components/ScanQRCode";

export function ScanPage() {
    const history = useHistory();

    return (
        <>
            <PageHeader/>
            <ScanQrCode
                show={true}
                onSuccess={(certificate: CertificateDto) => {
                    history.push('/certificates/' + certificate.id);
                }}
            />
        </>
    )
}
